import React from 'react';
import PropTypes from 'prop-types';
import {Avatar, Space} from 'antd';
import {StyledSubscriptionIconWithLink} from './StyledSubscriptionIconWithLink';
import IconWrapper from '../../../IconWrapper';
import {ExternalLinkIcon} from '../../../../icons';
import {
  objectHelpers,
  subscriptionsHelpers,
  textHelpers
} from '../../../../utils/helpers';

const SubscriptionIconWithLink = ({
  subscription,
  ...rest
}) => {
  const getServiceProp = (key) => objectHelpers.getObjProp(subscription?.service, key);

  const logo = getServiceProp('logo') || getServiceProp('logo_url');
  const name = subscriptionsHelpers.getSubscriptionName(subscription);
  const url = subscriptionsHelpers.getSubscriptionDetailsPageUrl(subscription);

  return (
    <Space align='center' className='d-flex-child' size={4} {...rest}>
      <Avatar src={logo}>
        {textHelpers.getInitials(name)}
      </Avatar>
      <StyledSubscriptionIconWithLink to={url}>
        <Space className='d-flex-child' size='small'>
          {name}
          <IconWrapper size={12}>
            <ExternalLinkIcon />
          </IconWrapper>
        </Space>
      </StyledSubscriptionIconWithLink>
    </Space>
  );
}

SubscriptionIconWithLink.propTypes = {
  subscription: PropTypes.object,
}

export default SubscriptionIconWithLink;
